/* eslint-disable */
<template>
  <div>
    <img :src="closeIcon" alt @click="close" class="close-icon" />

    <div class="preferences-modal">
      <div v-if="!isAuthReady" style="padding: 40px; text-align: center;">
        Loading...
      </div>
      <employee-hub-service
        v-else
        :service-id="serviceId"
        :platform-category="platformCategory"
        :current-user-access-token="authResponse.accessToken"
        :current-user="authResponse.user"
        :env="appEnv"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
const modalName = "manage-preferences-modal";

import { mapGetters, mapActions, mapMutations } from "vuex";
import closeIcon from "@/assets/close-icon.svg";

export default {
  name: modalName,
  data() {
    return {
      closeIcon,
      appEnv: CURRENT_ENV,
      platformCategory: "IT"
    };
  },
  props: {
    serviceId: String,
    token: String
  },
  computed: {
    ...mapGetters(["authResponse"]),
    isAuthReady() {
      return this.authResponse &&
             this.authResponse.accessToken &&
             this.authResponse.user;
    }
  },
  methods: {
    close() {
      this.$emit("update:modelValue", false);
    }
  },
  watch: {
    '$route' (to, from) {
      window.location.href = ''
    }
  }
};
</script>

<style scoped>
.modal-header {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom: 0;
}
.close-icon {
  position: absolute;
  right: 3rem;
  top: 1.5rem;
  z-index: 2;
  cursor: pointer;
}
</style>